export default "__VITE_ASSET__2e5f1307__"